import * as actionTypes from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';
import { UserCompanyRole } from '../../domain/UserCompanyRole';
import { Company } from '../../domain/Company';

export const selectCompanyStart = () => ({
  type: actionTypes.SELECT_COMPANY_START,
});

export const selectCompanySuccess = (selectedCompany: number) => ({
  type: actionTypes.SELECT_COMPANY_SUCCESS,
  selectedCompany,
});

export const selectCompanyFail = (selectCompanyError: HttpError) => ({
  type: actionTypes.SELECT_COMPANY_FAIL,
  selectCompanyError,
});

export const inviteToCompanyStart = () => ({
  type: actionTypes.INVITE_TO_COMPANY_START,
});

export const inviteToCompanySuccess = () => ({
  type: actionTypes.INVITE_TO_COMPANY_SUCCESS,
});

export const inviteToCompanyFail = (inviteToCompanyError: HttpError) => ({
  type: actionTypes.INVITE_TO_COMPANY_FAIL,
  inviteToCompanyError,
});

export const setSelectedCompany = (selectedCompany: number | null) => {
  selectedCompany &&
    localStorage.setItem('selectedCompany', selectedCompany.toString());

  return {
    type: actionTypes.SET_SELECTED_COMPANY,
    selectedCompany,
  };
};

export const fetchAllCompanyUsersStart = () => ({
  type: actionTypes.FETCH_ALL_COMPANY_USERS_START,
});

export const fetchAllCompanyUsersSuccess = (
  allCompanyUsers: UserCompanyRole[],
) => ({
  type: actionTypes.FETCH_ALL_COMPANY_USERS_SUCCESS,
  allCompanyUsers,
});

export const fetchAllCompanyUsersFail = (allCompanyUsersError: HttpError) => ({
  type: actionTypes.FETCH_ALL_COMPANY_USERS_FAIL,
  allCompanyUsersError,
});

export const fetchCurrentStart = () => ({
  type: actionTypes.FETCH_CURRENT_START,
});

export const fetchCurrentSuccess = (currentCompany: Company) => ({
  type: actionTypes.FETCH_CURRENT_SUCCESS,
  currentCompany,
});

export const fetchCurrentFail = (currentCompanyError: HttpError) => ({
  type: actionTypes.FETCH_CURRENT_FAIL,
  currentCompanyError,
});

export const updateCompanySignaturePriceStart = () => ({
  type: actionTypes.UPDATE_COMPANY_SIGNATURE_PRICE_START,
});

export const updateCompanySignaturePriceSuccess = () => ({
  type: actionTypes.UPDATE_COMPANY_SIGNATURE_PRICE_SUCCESS,
});

export const updateCompanySignaturePriceFail = (
  updateCompanySignaturePriceError: HttpError,
) => ({
  type: actionTypes.UPDATE_COMPANY_SIGNATURE_PRICE_FAIL,
  updateCompanySignaturePriceError,
});

export const removeUserFromCompanyStart = () => ({
  type: actionTypes.REMOVE_USER_FROM_COMPANY_START,
});

export const removeUserFromCompanySuccess = () => ({
  type: actionTypes.REMOVE_USER_FROM_COMPANY_SUCCESS,
});

export const removeUserFromCompanyFail = (
  removeUserFromCompanyError: HttpError,
) => ({
  type: actionTypes.REMOVE_USER_FROM_COMPANY_FAIL,
  removeUserFromCompanyError,
});
